// Contentful Entry ID for Privacy Act and Paperwork Reduction Act Notice
export const PRIVACY_NOTICE_ENTRY_ID = '27DAMvCMFmVwudDrRR2ecq';
